module.exports = __webpack_public_path__ + "media/paws/paws-bottom-left-fb6d4d5a.svg";